import {Alert, Button, Card, CardBody, CardTitle, CustomInput, FormGroup, Input, Media} from "reactstrap";
import {I18n} from "../../I18n/index";
import {GUEST} from "../../helpers/constants";
import {connect} from "react-redux";
import React, {Component} from "react";
import {fetchLatestClientUpdate, saveNewClientVersion} from "../../actions/clientUpdateActions";
import swal from "sweetalert";
import spinner from "../../assets/images/spinner.gif";
import './clientUpdate.css';

class ClientUpdate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            newClientUpdate: {
                url: null,
                version: null,
                forced: true,
                releaseNotes: []
            }
        }
    }

    componentDidMount() {
        (async () => {
            await this.props.fetchLatestClientUpdate();
        })();
    }

    isVersionValid = text => text && /^\d{1,2}\.\d{1,2}\.\d{1,2}\.\d{1,2}$/.test(text);

    isBlank = text => !text || text.trim().length === 0;

    isConflictError = response => response && response.status === 409;

    onInputChange = event => {
        console.log('value', event.value);
        const name = event.target.name;
        const value = event.target.value;
        this.setState(state => ({
            newClientUpdate: Object.keys(state.newClientUpdate).reduce((res, key) => {
                if (key === name) {
                    res[key] = value;
                } else {
                    res[key] = state.newClientUpdate[key];
                }
                return res
            }, {})
        }));
    };

    onForcedChange = event => {
        const {newClientUpdate} = this.state;
        newClientUpdate.forced = event.target.checked;
        this.setState({newClientUpdate});
    }

    onSaveNewVersion = () => {
        const {lang} = this.props;
        const {newClientUpdate} = this.state;
        if (!this.isVersionValid(newClientUpdate.version)) {
            this.showSimpleErrorSwal(I18n[lang].INCORRECT_VERSION_FORMAT);
        } else if (this.isBlank(newClientUpdate.url)) {
            this.showSimpleErrorSwal(I18n[lang].THIS_FIELD_CANNOT_BE_EMPTY + ": 'URL'");
        } else {
            this.props.saveNewClientVersion(newClientUpdate)
                .then(response => {
                    if (response) {
                        this.clearNewClientUpdateState()
                        swal({icon: "success"})
                            .then(async () => {
                                await this.props.fetchLatestClientUpdate()
                            });
                    }
                })
                .catch(error => {
                    if (this.isConflictError(error)) {
                        this.showSimpleErrorSwal(I18n[lang].THIS_VERSION_ALREADY_EXISTS);
                    } else {
                        this.showSimpleErrorSwal(I18n[lang].SOMETHING_WENT_WRONG);
                    }
                });
        }
    }

    showSimpleErrorSwal = message => {
        swal(message, "", "error");
    }

    clearNewClientUpdateState = () => {
        const {newClientUpdate} = this.state;
        newClientUpdate.url = "";
        newClientUpdate.version = "";
        newClientUpdate.forced = true;
        newClientUpdate.releaseNotes = [];
        this.setState({newClientUpdate});
    }

    render() {
        const {lang, latestUpdateVersionLoading, latestClientUpdate, saveUpdateLoading} = this.props;
        const {newClientUpdate} = this.state;
        return (
            <div>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-update mr-2"/>{I18n[lang].CLIENT_UPDATE}
                        </div>
                    </CardTitle>
                    <CardBody className="text-center">
                        {
                            latestUpdateVersionLoading
                                ? <Media
                                    className="w-8em"
                                    object
                                    src={spinner}
                                    alt="fetch spinner"
                                />
                                : latestClientUpdate
                                    ? <div className="mt-3">
                                        <h3>{I18n[lang].LATEST_AVAILABLE_VERSION}: {latestClientUpdate.version}</h3>
                                    </div>
                                    : null
                        }
                    </CardBody>
                    <CardBody>
                        <div className="text-center">
                            {
                                saveUpdateLoading
                                    ? <Media
                                        className="w-8em"
                                        object
                                        src={spinner}
                                        alt="upload spinner"
                                    />
                                    : <div>
                                        <h4 className="mb-3">{I18n[lang].CREATE_NEW_VERSION}</h4>
                                        <FormGroup>
                                            <Input
                                                className="text-center m-auto w-8em"
                                                type="text"
                                                name="version"
                                                maxLength="11"
                                                placeholder="0.0.0.0"
                                                id="version"
                                                value={newClientUpdate.version}
                                                onChange={this.onInputChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Input
                                                className="text-center m-auto w-40"
                                                type="text"
                                                name="url"
                                                placeholder="URL"
                                                id="url"
                                                value={newClientUpdate.url}
                                                onChange={this.onInputChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <CustomInput
                                                className="custom-checkbox"
                                                type="checkbox"
                                                id="forced"
                                                name="forced"
                                                label={I18n[lang].FORCE_UPDATE}
                                                checked={newClientUpdate.forced}
                                                onChange={this.onForcedChange}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Button
                                                color="primary"
                                                type="button"
                                                onClick={this.onSaveNewVersion}>
                                                {I18n[lang].CREATE}
                                            </Button>
                                        </FormGroup>
                                    </div>
                            }
                        </div>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchLatestClientUpdate: () => dispatch(fetchLatestClientUpdate()),
        saveNewClientVersion: query => dispatch(saveNewClientVersion(query)),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    latestUpdateVersionLoading: state.latestClientUpdateReducer.loading,
    latestClientUpdate: state.latestClientUpdateReducer.latestClientUpdate,
    saveUpdateLoading: state.saveClientUpdateReducer.loading,
    savedNewClientUpdate: state.saveClientUpdateReducer.savedNewClientUpdate,
    authority: state.currentUser.roles[0].authority || GUEST,
    lang: state.languageReducer.lang,
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientUpdate)



// WEBPACK FOOTER //
// ./src/components/ClientUpdate/ClientUpdate.js